import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import ProfileSection from "../components/Profile";
import FloatingSocialButtons from "../components/FloatingSocialButtons";

export default function Profile(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <FloatingSocialButtons />
      <div>
        <ProfileSection />
        <Footer />
      </div>
    </AppTheme>
  );
}
